// 画面遷移するたびに画面上部にスクロールする
export default function (to, from, savedPosition) {
  return { x: 0, y: 0 };
}
